import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { formatDate, formatMoney } from '@/lib/formatUtils';

export const getDataTableColumns = (handleViewClick: (row: BanHangRecord) => void): DataTableColumn[] => [
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: params => {
      const status = params.row.status;
      switch (status) {
        case '0':
          return 'Lập chứng từ';
        case '3':
          return 'Chờ duyệt';
        case '5':
          return 'Xuất hóa đơn';
        case '6':
          return 'Đã xuất hóa đơn điện tử';
        case '7':
          return 'Bỏ duyệt đơn hàng';
        default:
          return '';
      }
    }
  },
  {
    field: 'so_ct',
    headerName: 'Số c/từ',
    width: 140,
    renderCell: params => (
      <button
        onClick={e => {
          e.stopPropagation();
          handleViewClick(params.row);
        }}
        className='hover:text-blue-500 hover:underline'
      >
        {params.row.so_ct}
      </button>
    )
  },
  {
    field: 'ngay_ct',
    headerName: 'Ngày c/từ',
    width: 120,
    renderCell: params => formatDate(params.row.ngay_ct)
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200
  },
  {
    field: 't_ps_no_nt',
    headerName: 'Tổng tiền',
    width: 120,
    type: 'number',
    renderCell: params => formatMoney(params.row.t_ps_no_nt)
  },
  {
    field: 'ma_nt',
    headerName: 'Ngoại tệ',
    width: 120,
    renderCell: params => params.row.ma_nt_data?.ma_nt
  },
  {
    field: 'username0',
    headerName: 'Người tạo',
    width: 200
  },
  {
    field: 'datetime0',
    headerName: 'Ngày tạo',
    width: 120
  },
  {
    field: 'username2',
    headerName: 'Người sửa',
    width: 200
  },
  {
    field: 'datetime2',
    headerName: 'Ngày sửa',
    width: 120
  }
];

export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'tk',
    headerName: 'Tài khoản',
    width: 120,
    renderCell: params => params.row.tk_data?.code
  },
  {
    field: 'ten_tk',
    headerName: 'Tên tài khoản',
    width: 200,
    renderCell: params => params.row.tk_data?.name
  },
  {
    field: 'ma_kh',
    headerName: 'Mã đối tượng',
    width: 120
  },
  {
    field: 'ten_kh',
    headerName: 'Tên đối tượng',
    width: 200
  },
  {
    field: 'ps_no_nt',
    headerName: 'Ps nợ VND',
    width: 150,
    type: 'number',
    renderCell: params => formatMoney(params.row.ps_no_nt)
  },
  {
    field: 'ps_co_nt',
    headerName: 'Ps có VND',
    width: 150,
    type: 'number',
    renderCell: params => formatMoney(params.row.ps_co_nt)
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 200
  },
  {
    field: 'so_ct0',
    headerName: 'Số hóa đơn',
    width: 150
  },
  {
    field: 'ngay_ct0',
    headerName: 'Ngày hóa đơn',
    width: 150
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_sp_data?.ma_vt
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 120
  }
];
